import React from 'react'
import ReactDOM from 'react-dom'

import Application from './Application/Application'

import reportWebVitals from './reportWebVitals'

ReactDOM.render(
  <React.StrictMode>
    <Application />
  </React.StrictMode>,
  document.getElementById('root'),
)

reportWebVitals()
